import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { UserResponseInterface } from '@interfaces/user/user.response.interface';
import { NavController } from '@ionic/angular';
import { AbstractAuthGuard } from '@services/abstract/abstract.auth.guard';
import { AuthService } from '@services/auth/auth.service';

@Injectable()
export class CompletedUserGuard extends AbstractAuthGuard {
  constructor(
    protected authService: AuthService,
    protected router: Router,
    protected navCtrl: NavController,
  ) {
    super(authService, router);
  }

  protected check(user: UserResponseInterface): boolean {
    if (!user.idNumber) {
      this.navCtrl.navigateRoot('/admin/rs2');
      return false;
    }

    return true;
  }

  protected onError(e): boolean {
    return false;
  }
}
